import { Grid, Typography } from '@material-ui/core';
import { AdminTestContext } from '@orientaction/Context';
import { FC, useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';
import style from './style';

const Item: FC<any> = ({ response }) => {
  const { test } = useContext<any>(AdminTestContext);
  const classes = style();
  // fetch variable name from variable object to always get the latest update

  const variableName = (test?.variables || [])
    .filter((v: any) => {
      // S'assurer que response?.variable est traité comme un tableau, même s'il s'agit d'un seul objet ou est undefined/null
      const responseVariables = response?.variable;
      const variablesArray = Array.isArray(responseVariables)
        ? responseVariables
        : responseVariables
        ? [responseVariables]
        : [];

      return variablesArray.some((rv: any) => rv?.id === v?.id);
    })
    .map((v: any) => v?.name)
    .join(', ');

  const { diagram } = test.test;

  const isInterval = true;
  const hasImage = response?.image && response.image.length > 0;

  return (
    <div className={classes.responseItemContainer}>
      {hasImage ? (
        // Layout FLEXBOX pour les images - MÊME SYSTÈME QUE ResponseItem  
        <div className={classes.imageAccordionLayout}>
          <div className={classes.imageContainer}>
            <img 
              src={response.image} 
              alt="Réponse accordéon"
              className={classes.accordionResponseImage}
            />
          </div>
          
          <div className={classes.textInfoContainer}>
            {!isInterval && (
              <div className={classes.infoSection}>
                <Typography className={classes.variableNameLabel} component="div">
                  Variable liée :
                </Typography>
                <Typography className={classes.variableNameText} component="div">
                  {variableName}
                </Typography>
              </div>
            )}
          </div>
          
          <div className={classes.valueContainer}>
            <Typography className={classes.variableValueText} component="div">
              Valeur : {response?.variableValue}
            </Typography>
          </div>
        </div>
      ) : (
        // Layout FLEXBOX pour le texte 
        <div className={classes.textAccordionLayout}>
          <div className={classes.textContentContainer}>
            <Typography className={classes.responseTitle} component="p">
              {ReactHtmlParser(response.title)}
            </Typography>
            {!isInterval && (
              <div style={{marginTop: '8px'}}>
                <Typography className={classes.variableNameLabel} component="span">
                  Restitutions liées : 
                </Typography>
                <Typography className={classes.variableNameText} component="span">
                  {variableName}
                </Typography>
              </div>
            )}
          </div>
          
          <div className={classes.valueContainer}>
            <Typography className={classes.variableValueText} component="span">
              {isInterval ? 'Score : ' : 'Valeur : '} {response?.variableValue}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default Item;
